module.exports = __webpack_public_path__ + "img/logo-up-40.caa12592.png";